export default __webpack_public_path__ + "static/media/regulatory--no-overtaking--g4.22b05cd4.png";